import { Outlet, useRouteLoaderData } from 'react-router-dom';
import { useEffect } from 'react';
import type { PortalNavItem } from '@/types';
import { Masthead } from './Masthead';
import { PrimaryNav } from './PrimaryNav';
import { Footer } from './Footer';
import { BackToTop } from '../BackToTop';
import styles from './HomeLayout.module.css';

export function HomeLayout() {
  const data = useRouteLoaderData('root') as PortalNavItem | undefined;

  if (!data) {
    return null;
  }
  useEffect(() => {
    document.title = data.pageTitle;
  }, [data.pageTitle]);

  return (
    <div className={styles.shell}>
      {/* Skip-to-content — first focusable element on the page */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>

      <Masthead
        subTitle={data.portalSubTitle}
        mainTitle={data.portalMainTitle}
        partnerLogoAlt={data.partnerLogoAlt}
        partnerLogoHref={data.partnerLogoHref}
      />

      {data.menuItems.length > 0 && <PrimaryNav menuItems={data.menuItems} />}

      <main id="main-content" className={styles.main} tabIndex={-1}>
              <div className="container">
          <Outlet />
        </div>
      </main>

      <Footer
        privacyPolicy={data.privacyPolicy}
        accessibilityStmt={data.accessibilityStmt}
        termsOfUse={data.termsOfUse}
      />

      <BackToTop />
    </div>
  );
}
